function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcPrint = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.888,
    height: 25,
    viewBox: "0 0 25.888 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cb1ryb2npa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5555",
    style: {
      fill: "#333"
    },
    d: "M0 0h25.888v25H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2260"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2259"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2258",
    style: {
      clipPath: "url(#cb1ryb2npa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3827",
    d: "M0 15.359v-4.3a2.516 2.516 0 0 1 2.574-2.59c.643 0 1.287-.014 1.929 0 .308.009.4-.093.4-.4-.008-1.89-.003-3.782-.003-5.674A2.211 2.211 0 0 1 7.276.007c2.585 0 5.17 0 7.755-.007a1.2 1.2 0 0 1 .92.385q2.328 2.341 4.671 4.669a1.162 1.162 0 0 1 .372.923c-.022.717 0 1.435-.01 2.152 0 .261.092.346.347.342.692-.011 1.385-.01 2.078 0a2.493 2.493 0 0 1 2.474 2.489q.014 4.434 0 8.868a2.494 2.494 0 0 1-2.5 2.5c-.668.007-1.336.012-2 0-.279-.006-.391.066-.4.372a2.191 2.191 0 0 1-2.345 2.3H7.247a2.189 2.189 0 0 1-2.339-2.306c-.005-.309-.122-.376-.4-.37-.643.014-1.286.008-1.929 0A2.53 2.53 0 0 1 0 19.738v-4.379M12.937 10.3H2.88c-.782 0-1.043.264-1.043 1.051v5.9c0 .767-.008 1.534 0 2.3a.771.771 0 0 0 .875.867c.618.006 1.237 0 1.855 0 .233 0 .337-.072.333-.32q-.016-.965 0-1.93c0-.246-.1-.331-.333-.323a4.5 4.5 0 0 1-.63-.012.913.913 0 0 1-.816-.829.889.889 0 0 1 .649-1 1.73 1.73 0 0 1 .552-.047h17.556a.935.935 0 0 1 .048 1.865 3.559 3.559 0 0 1-.593.013c-.252-.012-.355.084-.35.345q.019.946 0 1.892c-.006.269.109.341.355.336.544-.011 1.089 0 1.633 0 .8 0 1.011-.211 1.011-1.012V11.38c0-.87-.223-1.093-1.1-1.093h-9.945m.029 7.571c-1.928 0-3.857.009-5.785-.008-.365 0-.458.115-.454.465.018 1.372.006 2.744.008 4.116 0 .556.154.716.7.716h11.013c.55 0 .7-.155.7-.707 0-1.384-.01-2.769.008-4.153 0-.348-.108-.439-.444-.436-1.916.014-3.832.007-5.748.007m-.044-9.391c1.928 0 3.857-.009 5.785.008.365 0 .483-.113.452-.465a5.829 5.829 0 0 1 0-.889c.019-.289-.083-.393-.379-.386-.766.016-1.533.01-2.3 0A2.2 2.2 0 0 1 14.254 4.5c-.006-.754-.014-1.508 0-2.262.007-.308-.1-.4-.4-.4-2.138.011-4.277 0-6.415.007-.551 0-.7.155-.7.707 0 1.829.008 3.659-.008 5.488 0 .347.107.439.444.437 1.913-.017 3.825-.01 5.745-.01M17.652 4.9l-1.561-1.569c0 .319-.009.689 0 1.058a.476.476 0 0 0 .484.507c.379.019.76 0 1.075 0",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3828",
    d: "M34.857 75.55a.917.917 0 1 1-1.832.046.99.99 0 0 1 .952-.98.874.874 0 0 1 .88.934",
    transform: "translate(-28.123 -63.539)",
    style: {
      fill: "#333"
    }
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcPrint);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-print.5af04375762b38ecc537b9a9a2ae585c.svg";